import styled from '@emotion/styled';
export const DispatcherWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  max-width: 1280px;
  margin-inline: auto;
`;
export const StyledBox = styled.div(({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.light['spacing.24']};
  flex: 1 1 auto;
  padding-left: 27px;
  padding-right: 27px;
  padding-top: 42px;
  max-width: 620px;
  margin-left: auto;
  margin-right: auto;
`);
export const StyledButtonWrapper = styled.div(({ theme }) => `
  position: sticky;
  bottom: 0;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  
  @media (min-width: 768px) {
    margin: ${theme.light['spacing.24']};
  }
`);
